import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { FeatureResolver } from '@luggagehero/shared/feature-resolution';
import { BookableStorageLocation, PricingModel } from '@luggagehero/shared/interfaces';
import { SharedPricingService } from '@luggagehero/shared/services/pricing';
import { firstValueFrom, Observable } from 'rxjs';

import { BaseComponent } from '../../../core';

@Component({
  template: '',
  standalone: false,
})
export abstract class PricingModelSelectorBaseComponent extends BaseComponent implements OnInit {
  private priceService = inject(SharedPricingService);
  private featureResolver = inject(FeatureResolver);
  private cd = inject(ChangeDetectorRef);

  @Input() public simpleMode = false;
  @Input() public storageLocation: BookableStorageLocation;

  private _hourlyRate: number;
  private _dailyRate: number;
  private _currency: string;
  private _isDailyRateDefault = false;
  private _isInitialized = false;

  public get pricingModel(): Observable<PricingModel> {
    return this.priceService.pricingModel$;
  }

  public get isDailyRateDefault(): boolean {
    return this._isDailyRateDefault;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  public get currency(): string {
    return this._currency || this.storageLocation?.pricing?.currency || 'usd';
  }
  @Input() set currency(value: string) {
    this._currency = value;
    this.cd.markForCheck();
  }

  public get hourlyRate(): number {
    return this._hourlyRate || this.storageLocation?.pricing?.hourlyRate;
  }
  @Input() set hourlyRate(value: number) {
    this._hourlyRate = value;
    this.cd.markForCheck();
  }

  public get dailyRate(): number {
    return this._dailyRate || this.storageLocation?.pricing?.dailyRate;
  }
  @Input() set dailyRate(value: number) {
    this._dailyRate = value;
    this.cd.markForCheck();
  }

  public ngOnInit() {
    void firstValueFrom(this.featureResolver.isDailyPricingDefault$).then((isEnabled) => {
      this._isDailyRateDefault = isEnabled;
      this._isInitialized = true;
      // The subclasses are OnPush and this resolves outside any input change, so without this the
      // selector stayed blank until something else happened to mark it (AM-5115: the modify modal).
      this.cd.markForCheck();
    });
  }

  public setPricingModel(value: PricingModel) {
    this.priceService.changePricing(value);
  }
}
